// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FDFK","badges":"styles_badges__1iIK8"};